<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp22',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-22">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-2 modules-id-22-content">
      <div
        v-for="v in moduleOption.list.slice(0, 2)"
        :key="`modules-22-${v.id}`"
        class="item"
        :style="{boxShadow: `0 4px 15px 0 ${getShadowColor(path)}`}"
        @click="onModuleItem(v)"
      >
        <el-image class="images" :src="v.photo | imgPath" alt="images" fit="cover" />
        <div class="title-box">
          <span class="title-line"></span>
          <p class="title-text">{{ v.headline | textLenHandler(28) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-22-content {
  display: flex;
  justify-content: space-between;
  .item {
    width: 344px;
    height: 328px;
    background: #fff;
    border-radius: 5px;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .images {
    width: 324px;
    height: 172px;
    border-radius: 5px;
  }
}
.title-box {
  width: 284px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 60px;
  .title-line {
    width: 4px;
    height: 16px;
    background: #DD4135;
    margin-top: 5px;
  }
  .title-text {
    width: 270px;
    font-size: 17px;
    font-weight: 800;
    color: #000;
    text-align: start;
    line-height: 25px;
    margin-left: 18px;
  }
}
</style>
